import TestPage from './TestPage';

export default TestPage;
